import Button from "../components/Button";
import Seo from "../components/Seo";
import apiDocs from "../JSON/api-docs.json";
import { useState } from "react";
import Cta from "../components/Cta";


const getSolarBlogsFromApiDocs = () => {
  const endpoints = apiDocs.paths;
  const blogs = [];
  Object.entries(endpoints).forEach(([path, methods], idx) => {
    Object.entries(methods).forEach(([method, details]) => {
      blogs.push({
        id: `${method}_${path}`,
        title: details.summary || `Endpoint: ${path}`,
        summary: details.description?.split('\n')[0] || "",
        author: "SolarAPP+ Docs",
        date: "2025-08-13",
        image: "https://images.unsplash.com/photo-1509395176047-4a66953fd231",
        link: "#"
      });
    });
  });
  return blogs;
};

const BlogPage = () => {
  const blogs = getSolarBlogsFromApiDocs();
      const [visibleCount, setVisibleCount] = useState(6); 
    const handleReadMore = () => {
    setVisibleCount((prev) => prev + 6); 
  };

  const visibleBlogs = blogs.slice(0, visibleCount);

  return (
    <>
      <Seo
        title="Solar Blog | Renewable Energy Tips & News | KK Solar"
        description="Read the latest solar energy tips, trends, and practical advice to power your home and business with clean, renewable energy."
        url="https://kksolar.co.in/blogs"
      />
      <div className="max-w-7xl mx-auto py-10">
      {/* Hero Section */}
      <section
        className="relative h-[55vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1581094794329-c8112a89d6e9?auto=format&fit=crop&w=1400&q=80')",
        }}
      >
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(2, 26, 92, 0.85)' }}></div>
        <div className="relative text-center max-w-3xl px-4 animate-fadeIn">
          <h1 className="text-5xl font-bold mb-4">Insights & Innovations in Solar Energy</h1>
          <p className="text-lg opacity-90">
      Read expert tips, latest trends, and practical advice to power your home and business with clean, renewable energy.
          </p>
        </div>
      </section>

      {/* Blog Section */}
      <h2 className="text-3xl font-bold mb-6 mt-10">Latest Blogs</h2>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
        {visibleBlogs.map(blog => (
          <div key={blog.id} className="border p-4 rounded shadow hover:shadow-lg transition">
            <img src={blog.image} alt={blog.title} className="w-full h-48 object-cover rounded mb-4"/>
            <h3 className="text-xl font-semibold mb-2">{blog.title}</h3>
            <p className="text-gray-600 mb-2">{blog.summary}</p>
            <p className="text-gray-400 text-sm">By {blog.author} on {blog.date}</p>
          </div>
        ))}
      </div>
      {/* Read More Button */}
      {visibleCount < blogs.length && (
        <div className="text-center mt-8">
          <Button
            onClick={handleReadMore}
          >
            Read More
          </Button>
        </div>
      )}

      <Cta/>
    </div>
  </>  
  );
};

export default BlogPage;
